import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/package',
    name: 'Package',
    component: () => import('../views/Package.vue')
  },
  {
    path: '/channel',
    name: 'Channel',
    component: () => import('../views/Channel.vue')
  },
  {
    path: '/topup',
    name: 'topUp',
    component: () => import('../views/topUp.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/Help.vue')
  },
  {
    path: '/newhelp',
    name: 'newHelp',
    component: () => import('../views/newHelp.vue')
  },
  {
    path: '/newhelpdetail',
    name: 'newHelpDetail',
    component: () => import('../views/newHelpDetail.vue')
  },
  {
    path: '/newhelpsearch',
    name: 'newHelpSearch',
    component: () => import('../views/newHelpSearch.vue')
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('../views/mine.vue')
  },
  {
    path: '/accessApi',
    name: 'AccessAPI',
    component: () => import('../views/AccessAPI.vue')
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import('../views/policy.vue')
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/service.vue')
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 不需要登录的页面
const noAuthPages = ['/', '/package','/topup','/channel', '/help', '/newhelp', '/newhelpdetail', '/newhelpsearch', '/policy', '/service']

// 登录框防抖标志
let isShowingLogin = false

router.beforeEach((to, from, next) => {
  const access_token = localStorage.getItem('access_token')
  const isNoAuthPage = noAuthPages.some(page => to.path === page || to.path.startsWith('/newhelp'))
  
  // 如果是无需登录的页面，直接放行
  if (isNoAuthPage) {
    next()
    return
  }
  
  // 未登录
  if (!access_token) {
    // 弹出登录框
    const store = require('../store/index').default
    store.commit('setLoginType', true)
    // 设置为登录模式（不是注册）
    store.commit('setRegisterType', null)
    
    // 保持当前页面，不跳转
    next(false)
  } else {
    next()
  }
})

// 导出重置函数，供登录成功后调用
export function resetLoginFlag() {
  isShowingLogin = false
}

export default router
